<template>
  <header id="main-header" class="site-header-wrap">
    <nav class="nav" id="mainNav" :class="{ scrolled }" data-component="navigation">
      <div class="nav-inner">
        <RouterLink :to="homeLink" class="nav-logo" @click="closeMobile">
          <img src="../assets/logo_d.svg" alt="海曦科技" />
        </RouterLink>

        <ul class="nav-links" :class="{ 'mobile-open': mobileOpen }" id="navLinks">
          <li class="nav-item">
            <RouterLink :to="homeLink" class="nav-link" @click="closeMobile">首页</RouterLink>
          </li>
          <li class="nav-item">
            <span
              class="nav-link has-dropdown"
              :class="{ active: isProductPage }"
              role="button"
              :aria-expanded="dropdownOpen"
              aria-haspopup="true"
              tabindex="0"
              @keydown="onDropdownKey"
            >
              {{ productNavLabel }}
            </span>
            <div class="nav-dropdown">
              <RouterLink
                to="/cloud-gaming"
                :class="{ active: route.name === 'cloud-gaming' }"
                @click="closeMobile"
              >
                <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="2" y="3" width="20" height="14" rx="2" />
                  <path d="M8 21h8M12 17v4" />
                </svg>
                云游戏
              </RouterLink>
              <RouterLink
                to="/computing-power"
                :class="{ active: route.name === 'computing-power' }"
                @click="closeMobile"
              >
                <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="4" y="4" width="16" height="16" rx="2" />
                  <path d="M9 9h6M9 12h6M9 15h3" />
                </svg>
                算力服务
              </RouterLink>
              <RouterLink
                to="/ai-acceleration"
                :class="{ active: route.name === 'ai-acceleration' }"
                @click="closeMobile"
              >
                <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12 2L2 7l10 5 10-5-10-5z" />
                  <path d="M2 17l10 5 10-5M2 12l10 5 10-5" />
                </svg>
                AI加速
              </RouterLink>
            </div>
          </li>
          <li class="nav-item">
            <RouterLink :to="casesLink" class="nav-link" @click="closeMobile">成功案例</RouterLink>
          </li>
          <li class="nav-item">
            <RouterLink :to="newsLink" class="nav-link" @click="closeMobile">新闻中心</RouterLink>
          </li>
          <li class="nav-item">
            <button type="button" class="nav-link" @click="goContact">加入我们</button>
          </li>
          <li class="nav-item">
            <RouterLink to="/about-haixi" class="nav-link" @click="closeMobile">关于海曦</RouterLink>
          </li>
        </ul>

        <button
          class="nav-toggle"
          :class="{ active: mobileOpen }"
          id="navToggle"
          aria-label="菜单"
          :aria-expanded="mobileOpen"
          @click="mobileOpen = !mobileOpen"
        >
          <span /><span /><span />
        </button>

        <RouterLink :to="contactLink" class="nav-cta" @click="closeMobile">联系我们</RouterLink>
      </div>
    </nav>
  </header>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { RouterLink, useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();
const scrolled = ref(false);
const mobileOpen = ref(false);
const dropdownOpen = ref(false);

const isHome = computed(() => route.name === 'home');
const isProductPage = computed(() =>
  ['cloud-gaming', 'computing-power', 'ai-acceleration'].includes(String(route.name))
);

const productNavLabel = computed(() => {
  const labels: Record<string, string> = {
    'cloud-gaming': '云游戏',
    'computing-power': '算力服务',
    'ai-acceleration': 'AI加速'
  };
  return labels[String(route.name)] ?? '产品方案';
});

const homeLink = computed(() => (isHome.value ? { path: '/', hash: '#hero' } : { path: '/' }));
const casesLink = computed(() =>
  isHome.value ? { path: '/', hash: '#success-cases' } : { path: '/', hash: '#success-cases' }
);
const newsLink = computed(() =>
  isHome.value ? { path: '/', hash: '#news' } : { path: '/', hash: '#news' }
);
const contactLink = computed(() => ({ path: '/', hash: '#cta-contact' }));

function closeMobile() {
  mobileOpen.value = false;
}

function goContact() {
  closeMobile();
  void router.push({ path: '/', hash: '#cta-contact' });
}

function onDropdownKey(e: KeyboardEvent) {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    dropdownOpen.value = !dropdownOpen.value;
  }
  if (e.key === 'Escape') {
    dropdownOpen.value = false;
  }
}

function onScroll() {
  scrolled.value = window.scrollY > 60;
}

onMounted(() => {
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
});

onUnmounted(() => {
  window.removeEventListener('scroll', onScroll);
});
</script>
